import { RefObject, useEffect } from "react";
import PrintContentWrapper from "src/component/PrintContentWrapper/PrintContentWrapper";
import { useGet } from "src/hooks/useGet";
import { GetRequestForPrint } from "src/requests/Shared";
import PrintableRequestTable from "./PrintableRequestTable";
import { errorToaster } from "src/utils";

interface PrintRequestProps {
    printRefs: RefObject<HTMLElement | null>[];
    handlePrint: (refs: RefObject<HTMLElement | null>[]) => Promise<void>;
    selectedPrintRequestId: number | null;
    setSelectedPrintRequestId: (id: number | null) => void
}
const PrintRequest = ({ printRefs, handlePrint, selectedPrintRequestId, setSelectedPrintRequestId }: PrintRequestProps) => {

    const { data: printRequestData, isPending: isPrinting, setData } = useGet<any>({
        API: GetRequestForPrint,
        depArr: [selectedPrintRequestId],
        isNotValid: !selectedPrintRequestId,
        params: [selectedPrintRequestId],
        defaultValue: null,
    });

    useEffect(() => {
        if (printRequestData && !isPrinting && selectedPrintRequestId) {
            const isMedicineAvailable = printRequestData?.medicines?.some((med: any) => med?.isAvailable);
            if (isMedicineAvailable) {
                handlePrint(printRefs);
            } else {
                errorToaster("thereIsNoAvailableMedicines");
            }
            setData(null);
            setSelectedPrintRequestId(null)
        }
    }, [handlePrint, printRefs, setData, selectedPrintRequestId, isPrinting, printRequestData, setSelectedPrintRequestId]);

    return (
        <>
            <PrintContentWrapper printRef={printRefs[0]} className="request-print-width" >
                <PrintableRequestTable data={printRequestData} />
            </PrintContentWrapper>

            <PrintContentWrapper printRef={printRefs[1]} className="request-print-width" >
                <PrintableRequestTable data={printRequestData} isNeedCooling />
            </PrintContentWrapper>
        </>
    )
}

export default PrintRequest;